import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';

import ChangePassword from 'views/ChangePassword';
import Login from 'views/Login';
import NotFound from 'views/NotFound';
import RecoverPassword from 'views/RecoverPassword';
import Register from 'views/Register';

const SignRoutes = () => {
  return (
    <HashRouter>
      <Switch>
        <Route exact path="/">
          <Redirect to="/login" />
        </Route>
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <Route path="/recover-password" component={RecoverPassword} />
        <Route path="/change-password" component={ChangePassword} />
        <Route path="*" component={NotFound} />
      </Switch>
    </HashRouter>
  );
};

export default SignRoutes;
